import TipsAndUpdatesOutlined from "@mui/icons-material/TipsAndUpdatesOutlined";
import { usePermissions } from "../../../server/auth/use-permissions";
import { useAccountLimitsContext } from "../../context/account-limit-context";
import { useLatestInsightsBatchCount } from "../../insights/hooks/use-latest-insights-batch-count";
import { HeaderCount } from "./header-count";

import type { FC } from "react";

/**
 * Insights from the most recent batch. Only super admins on accounts with communication insights
 * can see Insights (or read them), so it is hidden for everyone else, and if the count fails.
 */
export const NewInsightsCount: FC = () => {
  const { super_admin } = usePermissions();
  const { communication_insights } = useAccountLimitsContext();
  const enabled = super_admin && communication_insights;
  const { data: count, error } = useLatestInsightsBatchCount(enabled);

  if (!enabled || error) return null;

  return (
    <HeaderCount
      icon={<TipsAndUpdatesOutlined fontSize="small" />}
      to="/insights"
      count={count}
      noneTooltip="No new Insights"
      someTooltip="New Insights on Employee Engagement"
    />
  );
};
